// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .shade {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
:host .pop-up {
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 10px;
  height: 100vh;
}
:host .pop-up > .pop-up-box {
  overflow-y: auto;
  max-height: 100vh;
  max-width: 90vw;
  margin: 0 auto;
  width: auto;
  padding: 1rem;
  box-shadow: 5px 10px 8px 0px #5a5a5a;
  background: white;
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/provdir-modal/provdir-modal.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,oCAAA;AAAR;AAGI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;AADR;AAIQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,cAAA;AAFZ","sourcesContent":[":host {\n    .shade {\n        z-index: 1000;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        top: 0;\n        background-color: rgba(0, 0, 0, 0.5);\n    }\n\n    .pop-up {\n        z-index: 1001;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        box-sizing: border-box;\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        padding: 10px;\n        height: 100vh;\n        \n\n        >.pop-up-box {\n            overflow-y: auto;\n            max-height: 100vh;\n            max-width: 90vw;\n            margin: 0 auto;\n            width: auto;\n            padding: 1rem;\n            box-shadow: 5px 10px 8px 0px #5a5a5a;\n            background: white;\n            color: #000000;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
